// extracted by mini-css-extract-plugin
export default {"input":"reportPop_input__PKmEc"};